import { useEffect, useState } from 'react';
import { openClientReview, submitClientReview, resolveClientReviewAsset } from '../services/api';
import ResultDashboard from './ResultDashboard';
import Toaster from './Toaster';

export default function ClientReview({ token }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    openClientReview(token).then(value => { if (active) setData(value); })
      .catch(err => { if (active) setError(err.message || 'Review invitation unavailable.'); });
    return () => { active = false; };
  }, [token]);
  return <main className="app-shell is-product" style={{ padding: 24 }}>
    <h1>Private campaign review</h1>
    <p>This link permits viewing this saved campaign version and submitting one decision. Keep it private.</p>
    {error ? <p role="alert">{error}</p> : !data ? <p role="status">Loading invitation…</p> : <>
      <p>Invitation expires {new Date(data.invitation.expires_at).toLocaleString()}.</p>
      <ResultDashboard campaign={data.campaign} saved reviewMode existingReview={data.invitation.review}
        assetResolver={reference => resolveClientReviewAsset(token, reference)}
        onReviewDecision={(accepted, notes) => submitClientReview(token, accepted, notes)} />
    </>}
    <Toaster />
  </main>;
}
